module.exports={labels:["VPoE","CEO","チームリーダ","人事","CTO","エンジニア"],values:[2,3,4,5,7,12]};